var Dashboard = Dashboard || {};
Dashboard.CampaignDesigner = Dashboard.CampaignDesigner || {};

// FIXME: this should be a service -- if it gets converted, please
// make use
Dashboard.CampaignDesigner.TemplateListing = function(
    $scope,
    $state,
    userContext) {

    var self = this;
    self.templateType = undefined;
    self.scope = $scope;
    self.q = undefined;
    self.service = undefined;
    self.userContext = userContext;

    /**
     * Fetch the templates by the given state
     */
    function getTemplates() {
        var defer = self.q.defer();
        var brandId = self.userContext.BrandId;

        self.service.getCampaignTemplatesByState(self.templateType, brandId)
            .then(function(result){
                defer.resolve(result.data);
            })
            .catch(function(error){
                self.scope.grid.hasError = true;
                defer.reject(error);
            });

        return defer.promise;
    }

    /**
     * Sets up the grid
     */
    self.setupGrid = function setupGrid(
        templateType,
        scope,
        q,
        service,
        dtOptionsBuilder,
        dtColumnBuilder,
        $compile) {

        self.templateType = templateType;
        self.scope = scope;
        self.q = q;
        self.service = service;

        scope.grid = {
            hasError: false
        };

        var safeRender = window.Dashboard.CampaignDesigner.safeRender;

        scope.grid.dtOptions = dtOptionsBuilder
            .fromFnPromise(getTemplates)
            .withOption('paging', true)
            .withOption('searching', true)
            .withOption('processing', true)
            .withPaginationType('full_numbers')
            .withOption('responsive', true)
            .withOption('order', [[1, 'desc'], [2, 'asc']])
            .withOption('createdRow', function(row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            });

            var columnWidth = '50px';

            scope.grid.dtColumns = [
                dtColumnBuilder.newColumn('CampaignName')
                    .withTitle('Campaign Name')
                    .withOption('width', columnWidth),
                dtColumnBuilder.newColumn('StartDate')
                    .withTitle('Valid Start Date')
                    .withOption('width', columnWidth)
                    .renderWith(safeRender((data) => {
                        var date = new moment(data).format('DD MMMM YYYY');
                        return '<span style="display: none;">'+data+'</span>' + date;
                })),
                dtColumnBuilder.newColumn('EndDate')
                    .withTitle('Valid End Date')
                    .withOption('width', columnWidth)
                    .renderWith(safeRender(data => {
                        var date = new moment(data).format('DD MMMM YYYY');
                        return '<span style="display: none;">'+data+'</span>' + date;
                })),
                dtColumnBuilder.newColumn('Brand')
                    .withTitle('Brand')
                    .renderWith(safeRender(() => {
                        return self.userContext.BrandName;
                })).withOption('width', columnWidth),
                dtColumnBuilder.newColumn('CampaignLevelId')
                    .withTitle('Level').renderWith(safeRender((data, type, full) =>{
                        return self.GetLevelName(data);
                })).withOption('width', columnWidth),
                dtColumnBuilder.newColumn('TemplateGuid')
                    .renderWith(safeRender((data, type, full) => {
                        var html = _.template('<a ng-click="goToEditDraft($event,\'{0}\')" ><span class="btn btn-primary">View</span></a>'.format(full.TemplateGuid));
                        return html;
                })).withOption('width', columnWidth)
                    .withOption('sortable', false)
            ];
        scope.grid.dtInstance = null;
    }

    /**
     * Get the name of the given level id
     */
    self.GetLevelName = function GetLevelName(levelId){
        return Dashboard.Models.Lookups.CampaignLevelNames[levelId];
    }

    /**
     * Goes to the edit draft
     */
    $scope.goToEditDraft = function goToEditDraft(event, templateGuid){

        const manageBrandCampaignTemplates = "app.brandcampaigntemplates.manage";
        const params = {
            brandId: self.userContext.BrandId,
            CampaignTemplateGuid: templateGuid
        };

        if (event.ctrlKey) {
            const url = $state.href(
                manageBrandCampaignTemplates,
                params);

            window.open(url,
                "_blank");
        } else {
            $state.go(
                manageBrandCampaignTemplates,
                params);
        }
    }
};
